import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { FeaturesSection } from '../components/FeaturesSection';
import { SectorSection } from '../components/SectorSection';
import { MarketingSection } from '../components/MarketingSection';
import { ComparativaSection } from '../components/ComparativaSection';
import { IntegrationsSection } from '../components/IntegrationsSection';
import { PricingSection } from '../components/PricingSection';
import { SuccessStories } from '../components/SuccessStories';
import { HowItWorks } from '../components/HowItWorks';
import { QuienesSomos } from '../components/QuienesSomos';
import { FAQSection } from '../components/FAQSection';

export const Home: React.FC = () => {
  return (
    <>
      <HeroSection />
      <FeaturesSection />
      <SectorSection />
      <MarketingSection />
      <ComparativaSection />
      <IntegrationsSection />
      <PricingSection />
      <SuccessStories />
      <HowItWorks />
      <QuienesSomos />
      <FAQSection />
    </>
  );
};